<template>
  <section
    :class="[
      'mx-5 mb-10 flex items-center justify-center border-b pb-2.5 text-center md:mb-15 md:pb-3.75 xl:mx-10 xl:mb-17.5 xl:pb-3.75 2xl:mx-auto 2xl:mb-25 2xl:max-w-400',
      borderColor,
    ]"
  >
    <h1 class="text-[26px]/[115%] md:text-4.5xl/[105%] xl:text-6xl/[100%]">
      {{ title }}
    </h1>

    <NuxtLink
      v-if="showBack"
      :to="localePath(backLink || '')"
      class="absolute left-5 flex h-6 w-6 items-center justify-center rounded-full bg-white md:h-7.5 md:w-7.5 xl:left-10 xl:h-11 xl:w-11"
      :aria-label="t('common.back')"
    >
      <ArrowIcon
        class="h-3.5 w-3.5 rotate-180 text-black md:h-4 md:w-4 xl:h-6 xl:w-6"
      />
    </NuxtLink>
  </section>
</template>

<script setup lang="ts">
interface Props {
  title: string
  showBack?: boolean
  borderColor?: string
  backLink?: string
}

withDefaults(defineProps<Props>(), {
  showBack: false,
  borderColor: 'border-gray',
})

const { t } = useI18n()
const localePath = useLocalePath()
</script>
